import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import Container from '../../../components/Container';

import './style.scss';

const ProjectsCampaign = ({ entities }) => {
  return (
    <div className="View ProjectsCampaign">
      <Container>
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'col-12 col-lg-6';
            return (
              <div key={`${uuid}:${langcode}`} className={className}>
                <Node
                  id={id}
                  key={`${uuid}:${langcode}`}
                  isActivePath
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ProjectsCampaign;
